














import { Component, Vue,Prop } from 'vue-property-decorator'
import {MDCTopAppBar} from '@material/top-app-bar/index'
@Component({})
export default class MdcTabbar extends Vue{
  @Prop({default:'button'})
  tag!:string
  @Prop({default:undefined})
  tabindex:number|undefined

  @Prop({default:false})
  areaSelected!:boolean

  @Prop({default:false})
  stacked!:boolean

  @Prop({default:undefined})
  href!:string|undefined

  get _areaSelected(){
    return this.areaSelected ? 'true':'false'
  }
  @Prop({default:false})
  active!:boolean
  get _mdcTabCssClass(){
    return {
      'mdc-tab--active':this.active,
      'mdc-tab mdc-tab--stacked':this.stacked,
    }
  }

}
